import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-e73770ed-8f3f-4cff-9900-8eb984936a26-__Layer_2_00000124846972933553744120000014636231707679851453_",
  "enable-background": "new 0 0 512 512",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "ec-f994ff7b-a80b-4143-a104-b5c6b864da5b-__Icon",
      transform: "matrix(2.510572, 0, 0, 2.510572, -130.706482, -130.549515)"
    }, [
      _createElementVNode("path", {
        id: "ec-ff91e0d5-b0e3-4885-9be0-cd06701d6ed7-___21",
        d: "m256 154.5c-84.3 0-143 45.6-169.9 72.1-7.8 7.7-20.4 7.6-28.2-.1-7.8-7.8-7.8-20.6.1-28.4 9.2-9.1 21.4-19.8 36.4-30.6 48.5-34.7 104.4-53 161.6-53 34.3 0 68.2 6.6 100.3 19.4l-31.2 31.2c-22.3-7.1-45.4-10.6-69.1-10.6zm0 35.7c-63.6 0-113.7 32.3-144.6 59.6-8.7 7.6-9.1 21-.9 29.2 7.4 7.4 19.4 7.9 27.3.9 3.8-3.4 8-6.9 12.5-10.3 34-26.1 69.5-39.4 105.6-39.4 1.3 0 2.6 0 3.9.1l35.8-35.8c-12.4-2.8-25.7-4.3-39.6-4.3zm0 154.3c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zm-90.1-39.5c-6.8 6.2-8.2 15.9-4.4 23.7l55-55c-21.5 7.6-38.7 20.4-50.6 31.3zm288.1-106.9c-9.2-9.1-21.4-19.8-36.4-30.6-4.8-3.4-9.6-6.6-14.5-9.7l-29.1 29.1c6.5 3.8 12.9 7.9 19.2 12.4 13.6 9.6 24.6 19.3 32.7 27.3 7.9 7.7 20.4 7.7 28.2-.1 7.8-7.9 7.8-20.7-.1-28.4zm-53.4 51.7c-14-12.3-31.8-25.6-53-36.6l-30 30c14.9 6.4 29.6 15.2 44.1 26.3 4.5 3.5 8.7 7 12.5 10.3 7.9 7 19.9 6.5 27.3-.9 8.2-8.1 7.8-21.4-.9-29.1zm-111.3 21.8-35.1 35.1h1.8c27.5 0 49.9 15.7 63.1 27.8 7.9 7.2 20.1 6.9 27.6-.6 8-8 7.8-21.2-.6-28.9-13-12-32.3-26.1-56.8-33.4zm-159.7 145.5 304.1-304.1c5.9-5.9 5.9-15.4 0-21.2-5.9-5.9-15.4-5.9-21.2 0l-304.1 304c-5.9 5.9-5.9 15.4 0 21.2 5.8 6 15.3 6 21.2.1z",
        style: {"fill":"rgb(86, 86, 86)"}
      })
    ], -1)
  ]))]))
}
export default { render: render }